// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:600px){.pdfvuer-container[data-v-399f9a40]{margin-left:auto;margin-right:auto;max-width:66.6666666667%}}.pdfvuer-container--pdf[data-v-399f9a40]{width:100%}", ""]);
// Exports
module.exports = exports;
